import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { CustomSnackBarComponent } from "./custom-snack-bar.component";

@NgModule({
  declarations: [CustomSnackBarComponent],
  imports: [
    CommonModule
  ],
  entryComponents: [CustomSnackBarComponent]
})
export class CustomSnackbarModule { }